import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  UpdateRevenueCalculationMutation,
  UpdateRevenueCalculationMutationVariables,
  UpdateRevenueCalculationDocument,
  FetchTenderByIdDocument,
  FetchServicesOnTenderDocument,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook for updating revenue calculation and handling the necessary cache updates.
 * @returns {Object} - Contains the updateRevenueCalculationMutation function, loading state, and error state.
 */
export default function useUpdateRevenueCalculationMutationHook(): {
  updateRevenueCalculationMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [updateRevenueCalculationMutation, { loading, error }] = useMutation<UpdateRevenueCalculationMutation, UpdateRevenueCalculationMutationVariables>(
    UpdateRevenueCalculationDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "revenue-calculation-updated-success",
          data: {
            title: t("toasts.revenuecalculationupdated"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTenderByIdDocument,
          variables: { id: Number(tenderID) },
        },
        {
          query: FetchServicesOnTenderDocument,
          variables: { tenderId: Number(tenderID) },
        },
      ],
    });

  return {
    updateRevenueCalculationMutation,
    loading,
    error,
  };
}
